
import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import { ConstructionPackagesData } from "../../data/NewPackagesData";
import "../packages/Packages.css";
import PopupDialog from "../../components/common/PopupDialog";
import ContactForm from "../../components/contactForm/ContactForm";

export default function ConstructionPackage() {
    const [openQuote, setOpenQuote] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState("");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleGetQuote = (packageName) => {
        setSelectedPackage(packageName);
        setOpenQuote(true);
    };

    return (
        <Box className="packages-page">
            <Container>
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1f2937' }}>
                        Construction Packages
                    </Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '800px', mx: 'auto' }}>
                        Choose the perfect construction package that suits your budget and lifestyle. 
                        Transparent pricing with no hidden costs.
                    </Typography>
                </Box>

                <Grid container spacing={4} justifyContent="center">
                    {ConstructionPackagesData.map((pkg) => (
                        <Grid item xs={12} md={4} key={pkg.id}>
                            <Box className={`package-card ${pkg.recommended ? 'recommended' : ''}`}>
                                {pkg.recommended && (
                                    <div className="recommended-badge">Most Popular</div>
                                )}
                                <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                                    {pkg.name}
                                </Typography>
                                <Typography variant="h4" className="package-price">
                                    {pkg.price}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" >
                                    {pkg.description}
                                </Typography>
                                
                                <ul className="package-features">
                                    {pkg.features.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>

                                <Button 
                                    variant={pkg.recommended ? "contained" : "outlined"} 
                                    fullWidth
                                    sx={{ 
                                        mt: 2,
                                        borderColor: '#9d722d',
                                        color: pkg.recommended ? '#fff' : '#9d722d',
                                        bgcolor: pkg.recommended ? '#9d722d' : 'transparent',
                                        '&:hover': {
                                            bgcolor: pkg.recommended ? '#825e24' : 'rgba(157, 114, 45, 0.04)',
                                            borderColor: '#825e24'
                                        }
                                    }}
                                    onClick={() => handleGetQuote(pkg.name)}
                                >
                                    Get Quote
                                </Button>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            <PopupDialog 
                open={openQuote} 
                title={`Quote for ${selectedPackage}`} 
                onClose={() => setOpenQuote(false)} 
                maxWidth="md"
            >
                <ContactForm
                    title="Start Construction"
                    subtitle={`I'm interested in the ${selectedPackage}.`}
                    buttonText="Request Consultation"
                    onSubmit={() => setOpenQuote(false)}
                />
            </PopupDialog>
        </Box>
    );
}
